import { getAllOfflineRequests, clearOfflineRequests } from './indexedDB';
import { driveitupdate, driveitcreate, uploadimagesDriveIT } from '../api/api';

export async function syncOfflineData() {
    const requests = await getAllOfflineRequests();

    for (const req of requests) {
        try {
            if (req.type === 'update') {
                await driveitupdate(req.payload.user, req.payload.index, req.payload.update);
            } else if (req.type === 'create') {
                await driveitcreate(req.payload.user, req.payload.update);
            } else if (req.type === 'upload') {
                await uploadimagesDriveIT(req.payload.index, req.payload.image, req.payload.slot, req.payload.filename);
            }
        } catch (err) {
            console.warn("Erro ao sincronizar:", err);
        }
        alert('Itens offlines atualizados com sucesso')
    }

    await clearOfflineRequests();
}
